import styled from '@emotion/styled'

export const StyleAppShowCaseCardWrapper = styled.div`
  margin-top: 30px;
  width: 100%;
  overflow-x: auto;
  display: flex;
  gap: 16px;
  padding-bottom: 10px;
  &::-webkit-scrollbar {
    display: none;
  }
`
export const StyleAppShowCaseCard = styled.div`
  background-color: blue;
  border-radius: 20px;
  height: 600px;
  width: 80px;
  margin-right: 50px;
`
